// src/utils/seasonUtils.js

/**
 * Gets the current rugby season based on the current date
 * Rugby season typically runs August-May
 */
export function getCurrentSeason() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1; // 1-12

    // If month >= 8 (August or later), it's the year/year+1 season
    // Otherwise, it's year-1/year
    if (month >= 8) {
        return `${year}-${year + 1}`;
    } else {
        return `${year - 1}-${year}`;
    }
}

/**
 * Gets a list of recent seasons for dropdown selection
 * @param {number} count - Number of seasons to return (default: all seasons back to 2009-2010)
 */
export function getRecentSeasons(count = null) {
    const currentSeason = getCurrentSeason();
    const [startYear] = currentSeason.split('-').map(Number);

    // Default to all seasons back to 2009-2010 if count not specified
    const defaultCount = startYear - 2009 + 1;
    const seasonsCount = count || defaultCount;

    const seasons = [];
    for (let i = 0; i < seasonsCount; i++) {
        const year = startYear - i;
        seasons.push(`${year}-${year + 1}`);
    }

    return seasons;
}

/**
 * Formats a season string for display
 * @param {string} season - Season string like "2024-2025"
 */
export function formatSeason(season) {
    return season; // Already in a good format, but can be enhanced if needed
}

/**
 * Gets the current rugby season in the short format used by the Minis module
 * (e.g. "2026-27"), matching how Firestore minis documents key their season.
 */
export function getCurrentMinisSeason() {
    const [startYear] = getCurrentSeason().split('-').map(Number);
    return `${startYear}-${String((startYear + 1) % 100).padStart(2, '0')}`;
}

/**
 * Gets a list of recent seasons in short format ("2026-27") for dropdown selection
 * @param {number} count - Number of seasons to return (default: 3)
 */
export function getRecentMinisSeasons(count = 3) {
    const [startYear] = getCurrentMinisSeason().split('-').map(Number);

    const seasons = [];
    for (let i = 0; i < count; i++) {
        const year = startYear - i;
        seasons.push(`${year}-${String((year + 1) % 100).padStart(2, '0')}`);
    }

    return seasons;
}
